<script>
function formMinDate() {
  let minDate = new Date();
  let intervalDay = 5;
  if (minDate.getDay() === 5) {
    intervalDay = 7;
  }

  minDate.setDate(minDate.getDate() + intervalDay);
  return new Date(minDate);
}

export default {
  name: 'DatePicker',
  props: {
    placeHolder: {
      type: String,
      required: true
    },
    inputId: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false
    },
    onSelect: {
      type: Function,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    classNames: {
      type: String,
      default: ''
    }
  },
  methods: {
    onInputClick: function() {
      if (typeof this.onSelect === 'function') {
        this.onSelect();
      }
    }
  },
  mounted: function() {
    $('#' + this.inputId).datepicker({
      minDate: formMinDate(),
      onSelect: selectedDate => {
        this.$emit('onDateSelected', selectedDate, this.name);
      }
    });
  },

  updated: function() {
    if (this.show) {
      $('#' + this.inputId).datepicker('show');
      this.$emit('onDateShow');
    }
  }
};
</script>
<template>
  <input
    readonly
    :show="show"
    autocomplete="off"
    required
    type="text"
    :value="value"
    :placeholder="placeHolder"
    :id="inputId"
    @click="onInputClick"
    :class="'select date-picker has-datepicker ' + classNames"
  />
</template>
<style></style>
